import React from 'react';
import { PropTypes } from 'prop-types';
import { default as PagingView } from "react-js-pagination";

const Pagination = ({ currentPage, pageSize, totalCount, visibleRange, onPageChanged }) => (
  <div className="pagging">
    <PagingView
      hideDisabled={true}
      activePage={currentPage}
      itemsCountPerPage={pageSize}
      totalItemsCount={totalCount}
      pageRangeDisplayed={visibleRange}
      onChange={onPageChanged}
    />
  </div>
);

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  visibleRange: PropTypes.number.isRequired,
  onPageChanged: PropTypes.func.isRequired
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/common/Pagination.js